import { h } from 'preact';
import BaseComp from 'components/bolt/showtimes/showtimesMessage';
import HTML from 'components/core/html/html';
import Store from 'store/store';
import Button from 'components/bolt/button/button';
import { joinClasses, accessNested } from 'utils/utils';

import s from 'components/bolt/showtimes/showtimesMessage.sss';

export default class ShowtimesMessage extends BaseComp {
  
	onClick(e) {
		const elem = e.target.closest('a[data-track][data-action]');
		if (elem) {
			const isSameWindowLink = !elem.target || elem.target === '_self' || elem.target === '_top';
			const opensInSameWindow = isSameWindowLink && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.metaKey && e.button === 0;
			if (opensInSameWindow) {
				e.preventDefault();
			}
			const action = elem.getAttribute('data-action');
			const category = elem.getAttribute('data-track');
			const label = elem.getAttribute('data-label');
			Store.emit('CUSTOM_EVENT', { action, category, label });
			if (opensInSameWindow) {
				location.href = elem.href;
			}
		}
	}

	render(props) {
		const { isMap, deviceSize, noShowtimes, icon, regionButtonsOverride, isPreviewPanel } = props;

		const isMobileMap = isMap && deviceSize === 'mobile';

		const fontStyles = accessNested(Store.get(), 'appData.styling.fontVariables');

		return (
			<div class={joinClasses(s.container, props.class, isMobileMap && s.isMap, isPreviewPanel && s.previewPanel)}>
				<div class={s.topRow} key="toprow">
					{!props.noCalendar && (
						<div class={s.calendarEmpty} key="calendar">
							{this.renderIcon(icon)}
						</div>
					)}
					{noShowtimes && noShowtimes.video && this.renderVideo()}
					<HTML
						tag="span"
						class={joinClasses(s.message, fontStyles.showtimesErrorTitle)}
						content={props.message}
						markdown
						key="message"
						onClickCapture={this.onClick}
					/>
					{props.cta && (
						<HTML
							tag="span"
							class={joinClasses(s.ctaText, fontStyles.showtimesErrorDescription)}
							content={props.cta}
							markdown
							key="description"
						/>
					)}
				</div>
				{!noShowtimes && props.buttonCopy && (
					<Button
						type="primary"
						class={joinClasses(s.button, fontStyles.showtimesErrorButton)}
						trigger={this.triggerFunc}
						ariaLabel={props.buttonCopy}
						key="button"
					>
						{props.buttonCopy}
					</Button>
				)}
				{noShowtimes && this.renderButtons(noShowtimes, fontStyles, regionButtonsOverride)}
			</div>
		);
	}
}
